import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntCloudOutlinedSvg from "@ant-design/icons-svg/es/asn/AntCloudOutlined";
import AntdIcon from "../components/AntdIcon";
var AntCloudOutlined = function AntCloudOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AntCloudOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AntCloudOutlined.displayName = 'AntCloudOutlined';
}
export default /*#__PURE__*/React.forwardRef(AntCloudOutlined);